import type { SortOrder } from "@/types/sort-order";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const compareValues = (a: any, b: any, order: SortOrder): number => {
  if (typeof a === "string" && typeof b === "string") {
    return order === "ascended" ? a.localeCompare(b) : b.localeCompare(a);
  }
  if (typeof a === "number" && typeof b === "number") {
    return order === "ascended" ? a - b : b - a;
  }
  if (a instanceof Date && b instanceof Date) {
    return order === "ascended" ? a.getTime() - b.getTime() : b.getTime() - a.getTime();
  }
  return 0;
};
